export const PERMS = {
    READ: 'report_transport_orders.read',
}
